import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs text-foreground-400 tracking-[0.2em] uppercase mb-3 font-label">Explore Topics</p>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            探索你感兴趣的主题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto leading-relaxed">
            六个维度，六种方式，让慢生活渗透日常的每一个角落
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg aspect-[4/3] cursor-pointer"
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/15 to-transparent transition-opacity duration-300 group-hover:opacity-80"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="text-lg md:text-xl font-heading font-semibold text-white mb-1">
                  {cat.name}
                </h3>
                <p className="text-white/70 text-xs leading-relaxed line-clamp-2 hidden sm:block">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}